<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<span style="font-size: 10pt; margin-right: 10px;">{{ tokenStorageService.getUser().fullname }}</span>
<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5"> <img [src]="imgSrc" alt="user" class="profile-pic">
</button>
<mat-menu #profile="matMenu" class="mymegamenu">
    <button mat-menu-item (click)="openChangePasswordDialog()">
        <mat-icon>settings</mat-icon> Ubah Password
    </button>
    <button mat-menu-item (click)="openUpdateProfileDialog()">
        <mat-icon>account_box</mat-icon> Ubah Profile
    </button>
    <!-- <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon> Disable notifications
    </button> -->
    <button mat-menu-item [routerLink]="['/login']">
        <mat-icon>exit_to_app</mat-icon> Sign Out
    </button>
</mat-menu>